import moment from 'moment';
import { dateReg2, dateReg } from '../utils/formRules';

export function haveValidKeys(objArray, keys) {
  if (!objArray) return false;

  for (let i in objArray) {
    for (let k in keys) {
      if (!objArray[i]) return false;
      if (!objArray[i][keys[k]]) return false;
    }
  }
  return true;
}

export function getPid(searchString) {
  return Number(searchString.match(/^\?pid=(\d+)/)?.[1]) || 1;
}

export function getNc(searchString) {
  return Number(searchString.match(/[?&]nc=(\d+)/)?.[1]) || 1;
}

export function docility(number, normative = 'EHE') {
  const limitAccordinNormative = normative === 'EHE' ? 55 : 45;
  if (number >= 0 && number <= 25) {
    return 'dry';
  } else if (number > 25 && number <= limitAccordinNormative) {
    return 'plastic';
  } else if (number > limitAccordinNormative && number <= 95) {
    return 'soft';
  } else if (number > 95 && number <= 155) {
    return 'fluid';
  } else if (number > 155 && number <= 220) {
    return 'liquid';
  }
}

export function allAttrTrue(object) {
  for (const i in object) {
    if (!object[i].isSelected) return false;
  }
  return true;
}

export function allAttrAreValidated(object) {
  for (const i in object) {
    if (object[i].status === 'error') return false;
  }
  return true;
}

export var normalize = (function () {
  var from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç',
    to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc',
    mapping = {};

  for (var i = 0, j = from.length; i < j; i++)
    mapping[from.charAt(i)] = to.charAt(i);

  return function (str) {
    var ret = [];
    for (var i = 0, j = str.length; i < j; i++) {
      var c = str.charAt(i);
      if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c]);
      else ret.push(c);
    }
    return ret.join('');
  };
})();

export function normalizeTime(time) {
  var splittedTime = time.split(':');

  if (splittedTime.length === 3) return time;
  else if (splittedTime.length === 2) return time + ':00';
}
export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export function normalizeDate(date) {
  if (dateReg2.test(date)) return date;
  else if (dateReg.test(date)) {
    var splittedDate = date.split('/');

    if (String(splittedDate[2]).length < 4) {
      splittedDate[2] = '20' + splittedDate[2];
    }
    return splittedDate[2] + '-' + splittedDate[1] + '-' + splittedDate[0];
  }
}

export function denormalizeDate(date) {
  if (dateReg.test(date)) return date;
  else if (dateReg2.test(date)) {
    var splittedDate = date.split('-');

    if (String(splittedDate[0]).length < 4) {
      splittedDate[2] = '20' + splittedDate[2];
    }
    return splittedDate[2] + '/' + splittedDate[1] + '/' + splittedDate[0];
  }
}

export function getValue(str, obj) {
  if (typeof obj === 'object' && obj !== null)
    return str.split('.').reduce((o, d) => o[d], obj);
}

export const capitalizeFirstLetter = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const generateFileName = (entity, model, extension) => {
  return `${entity}_${model}_${Date.now()}.${extension}`;
};

export const calculateSeriesInterval = (dataSerie) => {
  if (dataSerie.length) {
    const firstChannel = dataSerie[0].channel;
    const serie = dataSerie.filter((d) => d.channel === firstChannel);
    return moment(serie[1].timestamp).diff(
      moment(serie[0]?.timestamp),
      'minutes',
    );
  }
  return 1;
};

export const shouldShowPoint = ({ currentDate, data, interval }) => {
  const timestamp = moment(currentDate);
  const dataSerie = data;
  const range = [
    moment(dataSerie[0]?.timestamp),
    moment(dataSerie[dataSerie.length - 1]?.timestamp),
  ];
  const minutesTotal = Math.floor(
    range[1].diff(range[0], 'minutes') / interval / 30, //max 30 items
  );

  const minutesSinceStart = Math.floor(timestamp.diff(range[0], 'minutes'));

  return minutesSinceStart % minutesTotal === 0;
};

const sortObjectKeys = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(sortObjectKeys);
  }

  return Object.keys(obj)
    .sort()
    .reduce((result, key) => {
      result[key] = sortObjectKeys(obj[key]);
      return result;
    }, {});
};

export const areObjectsEqual = (obj1, obj2) => {
  const sortedObj1 = sortObjectKeys(obj1);
  const sortedObj2 = sortObjectKeys(obj2);
  return JSON.stringify(sortedObj1) === JSON.stringify(sortedObj2);
};

export function getProject(pid) {
  const userProjects = JSON.parse(localStorage.getItem('projectsList'));
  const project = userProjects.find(
    (project) => project.id_project === parseInt(pid, 10),
  );
  return project;
}
